import {BookingStep} from "@page-containers/booking/utils/bookingStep";
import {CustomCategory, EventCategory, EventType} from "src/utils/analytics/constants";
import {getEventQueuer} from "src/utils/analytics/eventQueue";
import {getFlowId} from "src/utils/getFlowId";

const postEvent = getEventQueuer({
  category: EventCategory.Custom,
  extraData: {
    category: CustomCategory.AppointmentScheduling,
  },
});

export const postInputFieldEvent = ({
  viewId,
  typeId,
  value,
}: {
  viewId: string;
  typeId: EventType;
  value: string;
}) => {
  postEvent({
    typeId,
    extraData: {
      viewId,
      flowId: getFlowId() || null,
      value,
    },
  });
};

export const postBookItEvent = ({viewId, value}: {viewId: string; value: string}) => {
  postEvent({
    typeId: EventType.CompleteBookingClicked,
    extraData: {
      value,
      viewId,
      flowId: getFlowId() || null,
    },
  });
};

export const postViewEvent = ({
  viewId,
  apptReasonId,
  locationId,
  slotId,
  milesAway,
  timeToAppt,
  specialtyId,
}: {
  viewId: string;
  apptReasonId: string;
  locationId: string;
  slotId?: string;
  milesAway?: number;
  timeToAppt?: number;
  specialtyId: string;
}) => {
  postEvent({
    typeId: EventType.ProfileCreationStepViewed,
    extraData: {
      viewId,
      flowId: getFlowId() || null,
      bookingStep: BookingStep.ACCOUNT_CREATION,
      apptDetails: {
        specialtyId,
        apptReasonId,
        locationId,
        slotId,
        milesAway,
        timeToAppt,
      },
    },
  });
};
